import { useSelector } from 'react-redux';

export const useStyle = (options = {}) => {
	const sdk = useSelector(({ sdk }) => sdk.data);
	return {
		cookiebarBgColor: sdk?.cookiebarBgColor || '#ffffff',
		cookiebarTxtColor: sdk?.cookiebarTxtColor || '#000000',
		cookiebarLinkColor: sdk?.cookiebarLinkColor || '#007BFF',
		cookiebarBtnColor: sdk?.cookiebarBtnColor || '#007BFF',
		cookiebarBtnTxtColor: sdk?.cookiebarBtnTxtColor || '#ffffff',
		txtAlign: sdk?.txtAlign || 'left',
		cookiebarBtnTxt: sdk?.cookiebarBtnTxt || 'Aceito',
		cookiebarDetailedCategorization: sdk?.cookiebarDetailedCategorization || false,
		cookiebarDescription:
			sdk?.cookiebarDescription ||
			'<p>Cuidamos de seus dados e de sua privacidade. Você pode ler abaixo para entender como e para o quê utilizamos cookies, além de modificar suas preferências como quiser.</p>',
		...options,
	};
};
